import { render, staticRenderFns } from "./v-searchable-select.vue?vue&type=template&id=bedf9d6c&scoped=true&"
import script from "./v-searchable-select.vue?vue&type=script&lang=js&"
export * from "./v-searchable-select.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./v-searchable-select.vue?vue&type=style&index=1&id=bedf9d6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedf9d6c",
  null
  
)

export default component.exports